import React from 'react';
import ReactPlayer from "react-player"
import {
    Modal,
} from "reactstrap";

class PlayYouTubeVideo extends React.Component {

    render() {
      return (
        <>
          <Modal
              className="modal-dialog-centered"
              size="lg"
              isOpen={this.props.modalOpened}
              autoFocus={false}
          >
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {this.props.title}
              </h5>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={(e) => this.props.modalClose(e)}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div>
              {this.props.source ? (
                <ReactPlayer
                  url={this.props.source}
                  width="800px"
                  height="600px"
                  controls={true}
                />
              ) : (
                <div className="p-5 text-center">
                  <i className="fas fa-exclamation-triangle fa-2x text-warning mb-3" />
                  <p className="text-muted">
                    URL do vídeo não encontrada para este documento.
                  </p>
                </div>
              )}
            </div>
          </Modal>
        </>
      );
    }
  }
  
  export default PlayYouTubeVideo;